import React, { useCallback, useState } from 'react';

import Message from 'components/Message';
import Tooltip from 'components/Tooltip';

import {
  NotificationType,
  useSetNotificationShownMutation,
  useUserNotificationsQuery,
} from 'graphql/generated/graphql';

import { useAuth } from 'hooks/useAuth';
import useGraphaelDefaults from 'hooks/useGraphaelDefaults';

interface IProps {
  anchorEl: React.RefObject<HTMLDivElement>;
}

const OrgasmsTooltip = ({ anchorEl }: IProps) => {
  const [popperOpen, setPopperOpen] = useState<boolean>(false);
  const { isAuthenticated } = useAuth();

  useUserNotificationsQuery({
    ...useGraphaelDefaults(),
    onCompleted: (data) => {
      const shouldShowPopper = !data.userNotifications.find(
        (notification) =>
          notification.notificationType === NotificationType.OrgasmTooltip,
      );

      setPopperOpen(shouldShowPopper);
    },
    skip: !isAuthenticated,
  });

  const [setNotificationShown] = useSetNotificationShownMutation(
    useGraphaelDefaults(),
  );

  const onClick = useCallback(() => {
    setPopperOpen(false);
    if (isAuthenticated) {
      setNotificationShown({
        variables: { notificationType: NotificationType.OrgasmTooltip },
      });
    }
  }, [isAuthenticated, setNotificationShown]);

  return (
    <>
      {popperOpen && (
        <Tooltip
          open={popperOpen}
          onDismiss={onClick}
          anchorElement={anchorEl}
          message={
            <Message message={{ id: 'components.OrgasmsTooltip.content' }} />
          }
        />
      )}
    </>
  );
};

export default OrgasmsTooltip;
